/* Left sidebar for the Stock Admin and Payroll queues (NAV2, SA1). */
.sidebar {
  /* The section titles' band runs edge to edge, so it reads the side padding. */
  --sidebar-inline-pad: 14px;
  position: sticky;
  top: 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
  padding: 18px var(--sidebar-inline-pad);
  border: 1px solid var(--border-card);
  border-radius: var(--radius-md);
  background: var(--white);
  box-shadow: 0 2px 8px var(--navy-a05);
}

.group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Section titles: Oswald on a tinted band, so they stand apart from the links (APP-125). */
.groupLabel {
  margin: 0 calc(-1 * var(--sidebar-inline-pad)) 6px;
  padding: 8px calc(14px + var(--sidebar-inline-pad));
  background: var(--gray-100);
  color: var(--brand-navy);
  font-family: var(--font-display);
  font-size: 14px;
  font-weight: var(--fw-medium);
  letter-spacing: 0.08em;
  line-height: 1.3;
  text-transform: uppercase;
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: var(--control-height);
  padding: 0 12px 0 14px;
  border-radius: 4px;
  color: var(--brand-navy);
  font-size: 14px;
  font-weight: var(--fw-medium);
  text-decoration: none;
  transition:
    background-color var(--dur-fast) ease,
    color var(--dur-fast) ease;
}

.item:hover {
  outline: 1px solid var(--brand-cyan);
  color: var(--brand-navy);
}

.item[aria-current='page'] {
  background: var(--brand-navy);
  color: var(--white);
  font-weight: var(--fw-semibold);
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 22px;
  padding: 0 7px;
  border-radius: var(--radius-pill);
  background: var(--gray-100);
  color: var(--brand-navy);
  font-size: 12px;
  font-weight: var(--fw-bold);
  font-variant-numeric: tabular-nums;
}

.problem {
  background: var(--status-problem-bg);
  color: var(--status-problem-ink);
}

.item[aria-current='page'] .badge {
  background: var(--white-a18);
  color: var(--white);
}
